import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { ENVIRONMENT } from 'constants/environment';
import projectReducer from './slices/project/reducer';
import authReducer from './slices/auth/reducer';
import environmentReducer from './slices/environment/reducer';
import i18nReducer from './slices/i18n/reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
  environment: environmentReducer,
  i18n: i18nReducer,
});

const storeOptions = {
  reducer: rootReducer,
  devTools: ENVIRONMENT.NODE_ENV !== 'production',
};

const store = configureStore({
  ...storeOptions,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export default store;
